angular.module( 'acme.view.application.layouts.membership.cards.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.membership.cards.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsMembershipCardsList = {
        name: 'application.layouts.membership.cards.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'LayoutsMembershipCardsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/membership/cards/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Membership Cards Layouts',
          permissions: ['MEMBERSHIP_CARD_LAYOUTS_VIEW'],
          enablePreferences: true
        }
      };

    $stateProvider
      .state(layoutsMembershipCardsList);
});
